"use client";

import { Button } from "@package/subframe/components/Button";
import { FeatherCheck, FeatherX } from "@subframe/core";

/**
 * A pass/fail control that starts unset (AC13), so a check cannot be submitted
 * as a full pass without every unit actually being answered.
 */
export type PassFailValue = "pass" | "fail" | undefined;

interface PassFailControlProps {
  value: PassFailValue;
  onChange: (value: Exclude<PassFailValue, undefined>) => void;
  disabled?: boolean;
  /** Names the unit being judged, so the buttons are distinguishable to a screen reader. */
  label: string;
}

export function PassFailControl({
  value,
  onChange,
  disabled,
  label,
}: PassFailControlProps) {
  return (
    <div className="flex items-center gap-2" role="group" aria-label={label}>
      <Button
        type="button"
        variant={value === "pass" ? "positive-primary" : "neutral-secondary"}
        size="small"
        icon={<FeatherCheck />}
        onClick={() => onChange("pass")}
        disabled={disabled}
        aria-pressed={value === "pass"}
      >
        Pass
      </Button>
      <Button
        type="button"
        variant={value === "fail" ? "destructive-primary" : "neutral-secondary"}
        size="small"
        icon={<FeatherX />}
        onClick={() => onChange("fail")}
        disabled={disabled}
        aria-pressed={value === "fail"}
      >
        Fail
      </Button>
    </div>
  );
}
